import React from "react";
import g from "glamorous";
import Link from "gatsby-link";
import { FaPlus } from "react-icons/fa";

const Div = g.div({
  borderRadius: `0 0 4px 4px`,
  padding: `12px`,
  backgroundColor: `white`,
  color: `#1f1f1f`,
  border: `1px solid rgba(73,105,126,0.08)`,
  boxShadow: `0 1px 7px rgba(0,0,0,.05)`,
  margin: `0 0 2em`,
  transition: `all 0.15s ease-in-out`,
});

const Title = g.div({
  margin: `0 auto 1em`,
  letterSpacing: `0.05em`,
  fontSize: `1.2em`,
  paddingBottom: `3px`,
  color: `#49697e`,
  borderBottom: `2px solid #49697e`,
  fontWeight: `bold`,
});

const Date = g.div({
  fontSize: `.7em`,
  letterSpacing: `0.05em`,
  fontWeight: `600`,
  color: `#49697e`,
  marginBottom: `-3px`,
});

const NewsTitle = g.div({
  fontSize: `.95em`,
  lineHeight: `1.555em`,
  margin: `0 0 1.5em`,
  color: `#1f1f1f`,
  borderBotton: `none`,
  paddingBottom: `2px`,
  ":hover": {
    textDecoration: `underline`,
  },
});

const More = g.div({
  color: `#49697e`,
  fontSize: `14px`,
  textAlign: `right`,
});

export default ({ ...props }) => (
  <Div>
    <Title>Latest news</Title>

    <Date>08/17/2026</Date>
    <Link to="/en/discreet-consultation/">
      <NewsTitle>
        Discreet Consultation for public figures and international patients
      </NewsTitle>
    </Link>

    <Date>08/11/2026</Date>
    <Link to="/en/face/deep-plane-facelift/">
      <NewsTitle>Deep Plane Facelift</NewsTitle>
    </Link>

    <Date>01/17/2026</Date>
    <Link to="/en/skin/ultraclear-laser/">
      <NewsTitle>
        UltraClear<sup>®</sup>: an innovative laser based on infrared fiber
        technology
      </NewsTitle>
    </Link>

    <Date>07/10/2025</Date>
    <Link to="/en/breast/motiva-preserve/">
      <NewsTitle>
        Minimally invasive breast augmentation with Motiva Preserve
      </NewsTitle>
    </Link>

    <Date>03/20/2024</Date>
    <Link to="/en/face/neck-lift-platysmaplasty/">
      <NewsTitle>Neck lift by skin-and-muscle platysmaplasty</NewsTitle>
    </Link>

    <Date>01/25/2023</Date>
    <Link to="/en/news/sisthaema/">
      <NewsTitle>
        Sisthaema: a next-generation "Skinbooster" for more systematic and
        lasting skin regeneration
      </NewsTitle>
    </Link>

    <Date>01/06/2023</Date>
    <Link to="/en/eyes/plexr/">
      <NewsTitle>
        Plexr®: Treatment of eyelids, wrinkles and skin imperfections
      </NewsTitle>
    </Link>

    <More>
      <Link to="/en/news/" css={{ color: `#49697e` }}>
        <FaPlus
          css={{
            fontSize: `1em`,
            padding: `0 .3em 0.13em`,
            transform: `translateY(3px)`,
          }}
        />
        All news
      </Link>
    </More>
  </Div>
);
